const styles = {
  container:
    'relative w-full bg-gray-100 py-16 md:py-24 flex items-center justify-center',
  content:
    'bg-white dark:bg-black p-12 max-w-xs md:px-24 sm:py-16 md:max-w-3xl text-center flex flex-col items-center gap-y-4 z-10',
  title: 'md:text-xl font-bold',
  link: 'text-base hover:opacity-20 duration-200 font-bold flex flex-row items-center gap-x-2 uppercase',
  image: 'object-cover group-hover:scale-105 transition-all duration-300 -z-1',
};

export default styles;
